import { create } from 'zustand';

export interface SmartPartner {
  name?: string;
  headerName?: string;
}

interface SessionState {
  session: { partner?: SmartPartner; linkId?: string } | null;
  setPartner: (partner: SmartPartner) => void;
}

/** Gallery-only session stub — seeded from smartMock, never hits the network. */
export const useSessionStore = create<SessionState>((set) => ({
  session: {
    partner: { name: 'Lola Send', headerName: 'Lola Send' },
    linkId: 'gallery-smart-link',
  },
  setPartner: (partner) =>
    set((s) => ({
      session: { ...(s.session ?? {}), partner },
    })),
}));
